import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import { Link as LinkScroll } from 'react-scroll'

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/',
    },
    {
        id: 3,
        title: 'Soluções',
        link: '/',
        submenu: [
            {
                id: 31,
                title: 'Descrição de cargos',
                link: '/service-single/descricao-cargos'
            },
            {
                id: 3222,
                title: 'Pesquisa',
                link: '/service-single/pesquisa'
            },
        ]
    },
    {
        id: 4,
        title: 'Nosso propósito',
        link: '/about',
    },
    {
        id: 88,
        title: 'Contato',
        link: '/contact',
    }


]

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <ul className="main_menu_list clearfix">
            {menus.map((item, mn) => {                
                return (
                    <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                        {item.submenu ?
                            <Fragment>
                                <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                    <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                </p>
                                <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                    <List className="subMenu">
                                        <Fragment>
                                            {item.submenu.map((submenu, i) => {
                                                return (
                                                    <ListItem key={i}>
                                                        <Link onClick={ClickHandler} className="active"
                                                            to={submenu.link}>{submenu.title}</Link>
                                                    </ListItem>
                                                )
                                            })}
                                        </Fragment>
                                    </List>
                                </Collapse>
                            </Fragment>
                            : item.title != 'Contato' ? 
                            <Link className="active" to={item.link}>{item.title}</Link> 
                            : <LinkScroll style={{cursor:'pointer'}} to="contactSection">{item.title}</LinkScroll>
                        }
                    </ListItem>
                )
            })}
        </ul>
    )
}

export default MobileMenu;